
import { Injectable } from "@angular/core";
import { ApiService } from "@tylertech/core-module";
import { LookupItemViewModel, NewProjectDescriptor, ProjectEntryDescriptor } from "@tylertech/tyler-api-types";

/**
 * ProjectService is a generated service implementation. Any edits will be overridden!
 */
@Injectable()
export class ProjectService<TProject = unknown, TAccount = unknown, TPeriod = unknown> {
    constructor(private readonly $apiService: ApiService) { }
    
    CreateAndConfigureNewGrant(project: TProject): Promise<TProject> {
        return this.$apiService.sendAuth("IProjectService/CreateAndConfigureNewGrant", project);
    }
    CreateNewProject(): Promise<NewProjectDescriptor<TProject>> {
        return this.$apiService.sendAuth("IProjectService/CreateNewProject");
    }
    GetNewAccount(p: TProject): Promise<TAccount> {
        return this.$apiService.sendAuth("IProjectService/GetNewAccount", p);
    }
    GetNewPeriod(p: TProject): Promise<TPeriod> {
        return this.$apiService.sendAuth("IProjectService/GetNewPeriod", p);
    }
    GetProject(filterString?: string): Promise<TProject[]> {
        return this.$apiService.sendAuth("IProjectService/GetProject", null, filterString);
    }
    GetProjectEntryDescriptor(filterString?: string): Promise<ProjectEntryDescriptor> {
        return this.$apiService.sendAuth("IProjectService/GetProjectEntryDescriptor", null, filterString);
    }
    GetProjectSubFilters(groupBy: string): Promise<LookupItemViewModel[]> {
        return this.$apiService.sendAuth("IProjectService/GetProjectSubFilters", groupBy);
    }
    Save(project: TProject): Promise<TProject> {
        return this.$apiService.sendAuth("IProjectService/Save", project);
    }
}
